// redux/messageDraftsSlice.ts
import { createSlice, PayloadAction } from '@reduxjs/toolkit';

export interface DraftMedia {
  name: string;
  type: string;
  size: number;
  previewURL: string; // URL.createObjectURL(file)
}

export interface MessageDraft {
  text: string;
  media?: DraftMedia[];
  authorId: string;
}

export interface MessageDraftsState {
  [conversationId: string]: MessageDraft;
}

const initialState: MessageDraftsState = {};

const messageDraftsSlice = createSlice({
  name: 'messageDrafts',
  initialState,
  reducers: {
    saveDraft: (state, action: PayloadAction<{ conversationId: string; draft: MessageDraft }>) => {
      state[action.payload.conversationId] = action.payload.draft;
    },
    clearDraft: (state, action: PayloadAction<string>) => {
      delete state[action.payload];
    },
  },
});

export const { saveDraft, clearDraft } = messageDraftsSlice.actions;
export default messageDraftsSlice.reducer;
